var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.998,
    height: 20.997,
    viewBox: "0 0 20.998 20.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "paper-plane-top",
    d: "M18.985,7.334,4,.284A2.779,2.779,0,0,0,.173,3.738c.021.056,3.593,6.767,3.593,6.767S.261,17.211.241,17.266A2.785,2.785,0,0,0,2.854,21a2.722,2.722,0,0,0,1.207-.281l14.926-7.046a3.5,3.5,0,0,0,0-6.338ZM2.626,2.786a.158.158,0,0,1,.225-.14l.018.01,13.89,6.533H6.038ZM2.92,18.355a.132.132,0,0,1-.169-.023.136.136,0,0,1-.054-.119l3.349-6.4H16.778L2.921,18.356Z",
    transform: "translate(-0.002 -0.003)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.29941ee45d5982f48e95e2f189a87e04.svg";
export { ForwardRef as ReactComponent };